import {ConversionDataTypes} from "@/state/features/types";
import { Document, parse, stringify } from 'yaml'
import yaml, {YAMLException} from "js-yaml";
import xml2js from "xml2js";
import {CodeFormatter} from "@/lib/editor";


export const convertToJSON = (originalText: string, originalTextTypes: ConversionDataTypes): string | undefined  => {
    let convertedText = ""
    if(originalTextTypes === ConversionDataTypes.JSON) {
        return originalText;
    }
    else if(originalTextTypes === ConversionDataTypes.YAML) {
        return JSON.stringify(parse(originalText));
    }
    else if(originalTextTypes === ConversionDataTypes.XML) {
        const parser = new xml2js.Parser();
        parser.parseString(originalText, (err, result) =>{
            if(err){
                console.log(err);
                return;
            }
            convertedText = JSON.stringify(result);
        })
        return convertedText;
    }
    else if(originalTextTypes === ConversionDataTypes.CSV) {
        return ""
    }

}

export const convertJsonToSomething = (JSONTruth: string, convertedTextType: ConversionDataTypes) => {
    let convertedText = ""
    if(convertedTextType === ConversionDataTypes.JSON) {
        convertedText = JSONTruth;
    }
    else if(convertedTextType === ConversionDataTypes.YAML) {
        convertedText = yaml.dump(JSON.parse(JSONTruth)) as string;
        return convertedText;
    }
    else if(convertedTextType === ConversionDataTypes.XML) {
        const builder = new xml2js.Builder();
        return builder.buildObject(JSON.parse(JSONTruth));
    }
    else if(convertedTextType === ConversionDataTypes.CSV) {
        return ""
    }

    convertedText = CodeFormatter(convertedText, convertedTextType);
    return convertedText;

}
